import { Environments } from '@/config';
import { HELIX_TRIHEALTH_PRODUCTION } from './helix-trihealth.production';
import { HELIX_TRIHEALTH_STAGING } from './helix-trihealth.staging';

export const HELIX_TRIHEALTH =
  import.meta.env.MODE === Environments.PROD ? HELIX_TRIHEALTH_PRODUCTION : HELIX_TRIHEALTH_STAGING;
